
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultations/topics",
      function () {
        return require("private-next-pages/consultations/topics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultations/topics"])
      });
    }
  